// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";

function t(darkOpt, lightOpt, param) {
  var dark = darkOpt !== undefined ? darkOpt : ({
        bodyColour: Theme__Color$PrezzeeRibbon.Business.white,
        headingColour: Theme__Color$PrezzeeRibbon.Business.white,
        backgroundColor: Theme__Color$PrezzeeRibbon.Business.midPurple,
        borderRadius: Theme__Layout$PrezzeeRibbon.Business.borderRadius,
        svgColour: Theme__Color$PrezzeeRibbon.Business.white
      });
  var light = lightOpt !== undefined ? lightOpt : ({
        bodyColour: Theme__Color$PrezzeeRibbon.Business.bodyTextGrey,
        headingColour: Theme__Color$PrezzeeRibbon.Business.charcoal,
        backgroundColor: Theme__Color$PrezzeeRibbon.Business.veryLightGrey,
        borderRadius: Theme__Layout$PrezzeeRibbon.Business.borderRadius,
        svgColour: {
          NAME: "hex",
          VAL: "E8EEEF"
        }
      });
  return {
          dark: dark,
          light: light
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
